import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { ProgressTimerProps } from '.'
import { useStores } from '../../../data/store'
import styles from '../styles'

export const ProgressTimerMobile = ({ timeLeft }: ProgressTimerProps) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))

  const getFormattedTime = () => {
    let minutes: any = Math.floor(timeLeft / 60)
    let seconds: any = timeLeft - minutes * 60
    if (minutes < 10) {
      minutes = '0' + minutes
    }
    if (seconds < 10) {
      seconds = '0' + seconds
    }
    return {
      minutes,
      seconds,
    }
  }
  const { minutes, seconds } = getFormattedTime()

  console.log('ProgressTimerMobile', minutes, seconds)
  return (
    <Box mt={16} mb={32} alignSelf={'center'}>
      <Text testID={'timerText'} {...styles.expiryText(theme)} fontFamily={'jioType-medium'}>
        {'Your transaction expires in'}
      </Text>
      <Box flexDirection="row" alignSelf="center" mt={8} alignItems="flex-end">
        <Text fontFamily={'jioType-medium'} color={theme?.brandColor as ColorOptions} fontSize={24}>
          {minutes}
          <Text fontSize={12}> </Text>
          {':'}
          <Text fontSize={12}> </Text>
          {seconds}
        </Text>
        <Box pl={4} pb={4}>
          <Text fontFamily={'jioType-medium'} fontSize={12} color={theme?.bodyTextColor as ColorOptions}>
            s
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
